/**
 * main.js
 *
 * Application entry point. Creates the Vue app instance, registers
 * Vue Router and all plugins (Vuetify), then mounts the app to the
 * DOM element with id="app".
 *
 * Execution order:
 * 1. Import plugins (Vuetify configuration)
 * 2. Import the root App component
 * 3. Import Vue Router configuration
 * 4. Create the Vue application instance
 * 5. Install Vue Router
 * 6. Register all plugins (Vuetify)
 * 7. Mount to #app in index.html
 */

// Plugins
import { registerPlugins } from "@/plugins";

// Components
import App from "./App.vue";

// Vue Router
import router from "./router";

// Composables
import { createApp } from "vue";

// Thumbnail URL resolver (relative FYT paths → current API host)
import { resolveThumbnail } from "@/utils/thumbnail";

// Styles - auto-generated font imports from the unfonts Vite plugin
import "unfonts.css";

// Create the root Vue application instance with the App component
const app = createApp(App);

// Expose the thumbnail resolver to every template as $thumb(path), so views can
// render `:src="$thumb(episode.thumbnail_path)"` without per-component imports.
// Resolves relative covers against the API host (see utils/thumbnail.js).
app.config.globalProperties.$thumb = resolveThumbnail;

// Install Vue Router for client-side navigation
app.use(router);

// Register all additional plugins (currently just Vuetify)
registerPlugins(app);

// Mount the app to the #app element in public/index.html
app.mount("#app");
